<template>
  <BaseCard>
    <div v-if="currentCampaignType !== 'cpc'" class="tw:mb-10">
      <h3 class="tw:text-xl tw:font-bold tw:mb-4">
        {{
          currentCampaignType === 'netcpa' && campaignsData?.status !== 'PAUSED_UNTIL'
            ? $t('rc_ams_cpc_campaign')
            : $t('rc_markets_auto_header')
        }}
      </h3>
      <p>
        {{
          currentCampaignType === 'netcpa' && campaignsData?.status !== 'PAUSED_UNTIL'
            ? $t('rc_ams_cost_per_booking_campaign_subtext')
            : $t('rc_ams_cost_per_stay_campaign_subtext')
        }}
      </p>
    </div>
    <h3 class="tw:text-xl tw:font-bold tw:mb-4" v-if="currentCampaignType.toLowerCase() !== 'netcpa'">
      {{ $t('rc_high_value_markets', { ConnectivityProvider: currentPartner }) }}
    </h3>
    <div
      v-if="!marketsWithCampaign || marketsWithCampaign.length <= 0 || campaignsData?.status === 'PAUSED_UNTIL'"
      class="tw:text-gray-700 tw:text-base tw:text-center tw:mb-5"
    >
      <p class="tw:font-bold">{{ $t('rc_no_markets_paused_campaign_header') }}</p>
      <p>{{ $t('rc_no_markets_paused_campaign_subtext') }}</p>
    </div>
    <ul class="tw:gap-3 tw:md:gap-6 am-tile-grid">
      <li v-for="{ marketCode, domain } in marketsWithCampaign" :key="marketCode">
        <MarketItem
          :market-name="$t(`locale_${marketCode}`)"
          :domain="domain"
          :market-code="marketCode"
          class="tw:border tw:rounded-xl tw:border-green-700 tw:py-3 tw:px-4 tw:md:px-6"
        />
      </li>
    </ul>
  </BaseCard>
</template>

<script setup>
import BaseCard from '@/components/dashboard/BaseCard.vue'
import MarketItem from '@/components/rateConnect/markets/MarketItem.vue'

defineProps({
  currentCampaignType: {
    type: String,
    defaut: null,
  },
  marketsWithCampaign: {
    type: Array,
    default: () => [],
  },
  currentPartner: {
    type: String,
    default: '',
  },
})
</script>

<style scoped>
.am-tile-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(284px, 1fr));
}
</style>
